import { AutoMap } from "@automapper/classes";
import { MaterielEauDTO } from "./materiel-eau.dto";

export class MeasureEauDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    samplingID!: number;
    @AutoMap()
    samplingTime?: string;
    @AutoMap()
    materielEau!: MaterielEauDTO
    @AutoMap()
    isCancelled!: boolean;
    @AutoMap()
    observation!: string;
    @AutoMap()
    takeAnotherDay!: boolean
    @AutoMap()
    referenceEtiquette?: string
    @AutoMap()
    position!: number;
}